import styled from 'styled-components';

export const StyledProcessingBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .label {
    text-align: center;
  }
`;

export const StyledProcessingRefresh = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
`;
